import type { QROption } from '~/types/qrStatic'
import { getQRList } from '~/lib/api/qrStatic'

interface QRStaticState {
  qrOptions: QROption[]
  isLoading: boolean
  hasFetched: boolean
}

export const useQRStaticStore = defineStore('qrStatic', {
  state: (): QRStaticState => ({
    qrOptions: [],
    isLoading: false,
    hasFetched: false,
  }),

  getters: {
    // Check if QR menu should be visible (has QR options available)
    hasQRAccess: state => state.qrOptions.length > 0,
    getQROptions: state => state.qrOptions,
  },

  actions: {
    async fetchQRList() {
      // Skip if already fetching or already fetched
      if (this.isLoading || this.hasFetched) {
        return
      }

      this.isLoading = true
      try {
        const response = await getQRList()
        this.qrOptions = response.data || []
        this.hasFetched = true
      }
      catch (err) {
        console.error('Error fetching QR list:', err)
        this.qrOptions = []
        this.hasFetched = true
      }
      finally {
        this.isLoading = false
      }
    },

    reset() {
      this.qrOptions = []
      this.isLoading = false
      this.hasFetched = false
    },
  },
})
